import React, { useCallback, useEffect, useState } from 'react';

import { isNull } from 'lodash';

import Dialog from 'components/Dialog';

import {
  AssignmentSkeleton,
  EmptyAssignment,
  FeedbackEditingTool
} from './components';
import styles from './styles.module.scss';

const StudentWorkInsightsDialog = ({
  activeTask,
  activeWork,
  setActiveTask,
  setActiveWork,
  studentName,
  onClose,
  refetchStudentWork,
  refetchAssignment,
  gotoPrevTask,
  gotoNextTask,
  gotoNextUngradedTask
}) => {
  const [loadingEnded, setLoadingEnded] = useState(false);

  const handleDialogClose = useCallback(() => {
    refetchStudentWork();
    onClose();
  }, [onClose, refetchStudentWork]);

  useEffect(() => {
    if (!isNull(activeTask) && !isNull(activeWork)) setLoadingEnded(true);
  }, [activeTask, activeWork]);

  return (
    <Dialog
      open
      onClose={handleDialogClose}
      scroll="paper"
      classes={{ paper: styles.dialog }}
      disableEnforceFocus
      disableAutoFocus
    >
      <div className={styles.container}>
        {!loadingEnded && <AssignmentSkeleton />}
        {loadingEnded && !activeWork && !activeTask && <EmptyAssignment />}
        {loadingEnded && activeWork && activeTask && (
          <FeedbackEditingTool
            activeTask={activeTask}
            activeWork={activeWork}
            setActiveTask={setActiveTask}
            setActiveWork={setActiveWork}
            studentName={studentName}
            refetchAssignment={refetchAssignment}
            gotoPrevTask={gotoPrevTask}
            gotoNextTask={gotoNextTask}
            gotoNextUngradedTask={gotoNextUngradedTask}
          />
        )}
      </div>
    </Dialog>
  );
};

export default StudentWorkInsightsDialog;
